import { initInteractionTracking } from "@solvari/argus";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import { initCookiePopup } from "@solvari/components";

import { initExpertVueIslands } from "@/scripts/components/vueIslands";
import { initGtmLinkTracking } from "@/scripts/utils/gtmLinkTracking";

import { lazyLoadIntersection } from "./utils/lazyLoadIntersection.js";

import "./utils/sentry";
import "./components/fitty.js";
import "./components/fontAwesomeLists.js";
import "./components/headerMobile";
import "./components/popupHandler.js";
import "./utils/linkPrefetch.js";

function initBase() {
  initCookiePopup();
  initInteractionTracking();
  initGtmLinkTracking();
  initFontAwesome();
  initExpertVueIslands();
  lazyLoadIntersection();
}

export { initBase };
